export type DocumentTypeCode = 'DMS' | 'MOR';

export enum DocumentTypes {
  MultipleOrders = 'MOR',
  DemandSchedule = 'DMS',
}

export interface UploadFileReq {
  // This should be the customer's SAP code, which is currently supplied as legalEntityTypeCode by /v5/m/legalEntities
  customerId: string;
  countryCode: string;
  documentTypeCode: DocumentTypeCode;
  file: File;
  serviceCenterTblId?: number;
  productLineId?: number;
}

export interface UploadV7FileReq {
  customerCode: string;
  countryCode: string;
  documentTypeCode: DocumentTypeCode;
  file: File;
  serviceCenterTblId?: number;
}
